import React from 'react';
import { connect } from 'react-redux';

import {
    ALERT,
} from '../../constants/modalType';

import AlertModal from '../InstructionModal/InstructionModal';

const ModalSwitch = ({ modalProps, modalType }) => {
    switch (modalType) {
        case ALERT:
            return (<AlertModal {...modalProps} />);
        default:
            return null;
    }
};

const mapStateToProps = state => ({
    modalProps: state?.modal?.modalProps,
    modalType: state?.modal?.modalType,
});

export default connect(mapStateToProps, {})(ModalSwitch);
